import { Injectable } from '@angular/core';
import { NbToastrService } from '@nebular/theme';

// ### SERVIZIO DI NOTIFICHE ###

export enum ToastrIcons {
  Success = "checkmark-square-2-outline",
  Info = "bulb-outline",
  Warn = "alert-triangle-outline",
  Error = "alert-circle-outline",
  Message = "email-outline",
}

@Injectable({
  providedIn: 'root'
})
export class NotifierService {

  duration: number;
  position: string;

  constructor(
    private toastrService: NbToastrService
  ) {
    this.position = "top-right";
    this.duration = 7000;
  }

  error(title: string, message: string): void {
    this.toastrService.show(
      message,
      title,
      {
        // @ts-ignore
        position: this.position,
        // @ts-ignore
        status: "danger",
        // @ts-ignore
        icon: ToastrIcons.Error ,
        duration: this.duration,
        destroyByClick: true,
        preventDuplicates: false,
        hasIcon: true,
      },
    );
  }

  warning(title: string, message: string): void {
    this.toastrService.show(
      message,
      title,
      {
        // @ts-ignore
        position: this.position,
        // @ts-ignore
        status: "warning",
        // @ts-ignore
        icon: ToastrIcons.Warn ,
        duration: this.duration,
        destroyByClick: true,
        preventDuplicates: false,
        hasIcon: true,
      },
    );
  }

  success(title: string, message: string): void {
    this.toastrService.show(
      message,
      title,
      {
        // @ts-ignore
        position: this.position,
        // @ts-ignore
        status: "success",
        // @ts-ignore
        icon: ToastrIcons.Success ,
        duration: this.duration,
        destroyByClick: true,
        preventDuplicates: false,
        hasIcon: true,
      },
    );
  }

  info(title: string, message: string): void {
    this.toastrService.show(
      message,
      title,
      {
        // @ts-ignore
        position: this.position,
        // @ts-ignore
        status: "info",
        // @ts-ignore
        icon: ToastrIcons.Info ,
        duration: this.duration,
        destroyByClick: true,
        preventDuplicates: false,
        hasIcon: true,
      },
    );
  }

  message(title: string, message: string): void {
    this.toastrService.show(
      message,
      title,
      {
        // @ts-ignore
        position: this.position,
        // @ts-ignore
        status: "primary",
        // @ts-ignore
        icon: ToastrIcons.Message ,
        duration: this.duration,
        destroyByClick: true,
        preventDuplicates: false,
        hasIcon: true,
      },
    );
  }

}
